const translateErrorMessage = ({ networkError, graphQLErrors }) => {
  if (networkError) {
    return "Erro de rede";
  }

  return graphQLErrors.map(({ message }) => message).join(", ");
};

export default translateErrorMessage;
